export const routes = (prefix = `renal`) => [
    {
        path: `/${prefix}/queue`,
        name: `${prefix}.queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.queue.index`,
                PageDescription: "Renal Queue",
            },
        },
    },
]